import { siteApiSlice } from "../../../app/siteApiSlice";
import { ReviewGroupWriterModel } from "../peerReviewGroupsApiSlice";

export interface CoursePromptReviewGroupsViewModel {
	defaultGroups: CoursePromptsGroupInfo;
	coursePromptGroups: CoursePromptsGroupInfo;
	allWriters: ReviewGroupWriterModel[];
	canRandomizeGroups: boolean;
	canChangeGroups: boolean;
}

export interface CoursePromptsGroupInfo {
	groupsPage: CoursePromptReviewGroup[];
	availableWriterPool: ReviewGroupWriterModel[];
}

export interface CoursePromptReviewGroup {
	id: number;
	uniqueId: string;
	name: string;
	studentIds: number[];
}

export const coursePromptReviewGroupsApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		randomizeCoursePromptGroups: build.query<CoursePromptReviewGroup[], number>({
			query: (minSize) => ({
				url: `/CoursePrompts/RandomizeGroups`,
				params: { minSize },
			}),
		}),
		addCoursePromptGroup: build.mutation<
			void,
			{ group: CoursePromptReviewGroup; promptId: number }
		>({
			query: (payload) => ({
				url: `/CoursePrompts/AddNewCoursePromptGroup`,
				method: "POST",
				body: payload,
			}),
		}),
	}),
});

export const { useLazyRandomizeCoursePromptGroupsQuery, useAddCoursePromptGroupMutation } =
	coursePromptReviewGroupsApiSlice;
